export default{
  label:'add-border',
  addBorder:true,
  list:{
    all : 'border',
    top : 'border-top',
    right : 'border-right',
    bottom : 'border-bottom',
    left : 'border-left',
  },
}


// WEBPACK FOOTER //
// ./src/shell/schemas/general/border/add.js